export enum SkuAnnotationType {
	TextBox = 'textbox',
	Doodle = 'doodle',
	Line = 'line',
	Rectangle = 'rectangle',
	Ellipse = 'ellipse'
}
